import React from 'react';
import '../css/Ourfleet.css';
import { Link } from 'react-router-dom';

const Ourfleet = () => {
  const bookingData = [
    {
      id: 1,
      imgSrc: '/images/resource/dezire.png',
      title: 'Swift Desire',
      description: 'The Swift Desire by Etravo is ideal for city rides and short-distance travel. It offers a smooth driving experience, perfect for solo commuters or couples needing quick and comfortable urban transport.',
    },
   
    
    {
      id: 9,
      imgSrc: '/images/resource/crysta.jpg',
      title: 'Innova Crysta',
      description: 'The Innova Crysta from eTravo offers a perfect blend of comfort, style, and reliability. Ideal for business travel, airport transfers, or small group outings, it ensures a smooth and premium travel experience.',
    },
    {
      id: 10,
      imgSrc: '/images/resource/sedan.png',
      title: 'Sedan Cars',
      description: 'The Sedan fleet from eTravo is tailored for comfortable and efficient travel, offering a smooth ride with refined interiors. Ideal for executive travel, airport transfers, or city commutes with a touch of class.',
    },
    {
      id: 11,
      imgSrc: '/images/resource/bmw.png',
      title: 'BMW',
      description: 'The BMW from eTravo combines luxury, performance, and elegance to deliver an exceptional travel experience. Ideal for VIP movements, high-level executive travel, or special occasions where style and sophistication matter.',
    },
    {
      id: 12,
      imgSrc: '/images/resource/audi.png',
      title: 'Audi',
      description: 'The Audi from eTravo offers a seamless blend of advanced technology, luxury, and dynamic performance. Ideal for executive travel, VIP transfers, or special events where comfort and prestige are a priority.',
    },
     {
      id: 7,
      imgSrc: '/images/resource/ac-tempo.jpg',
      title: 'Tempo Traveller',
      description: 'For group outings or tours, Etravo’s Tempo Traveller is the go-to choice. With ample legroom and storage, it’s built for comfortable long-distance travel with friends or extended families.',
    },
    {
      id: 8,
      imgSrc: '/images/resource/minibus.png',
      title: 'Mini Bus',
      description: 'The Mini Bus from Etravo is designed for group travel with enhanced seating capacity and comfort. Ideal for corporate events, school trips, or large family vacations.',
    },

    {
      id: 13,
      imgSrc: '/images/resource/50.png',
      title: '50 Seater Bus',
      description: 'Etravo’s 50 Seater Luxury Bus is perfect for large-scale travel, offering maximum capacity with top-tier comfort and safety. Best suited for tours, events, or pilgrimage trips.',
    },
     {
      id: 15,
      imgSrc: '/images/resource/8.jpg',
      title: 'Volvo Bus',
      description: 'Etravo’s Volvo Bus offers a high-end travel experience with luxury seating and advanced features. Tailored for premium intercity and long-distance journeys in total comfort.',
    },
    {
      id: 14,
      imgSrc: '/images/resource/9.jpg',
      title: 'Corporate Bus',
      description: 'The 35 Seater Corporate Bus by Etravo provides a professional and comfortable travel option for medium-sized groups. Equipped for long journeys and ideal for corporate tours or team travel.',
    },
   
  ];

  const slugify = (text) =>
    text.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');

  return (
    <div>
      <section
        className="page-title"
        style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1>Our Fleets</h1>
          <div className="bread-crumb-outer"></div>
        </div>
      </section>

      {/* <EnquiryForm /> */}

      <section className="our-booking">
        <div className="container">
          <div className="row g-4">
            {bookingData.map((booking) => (
              <div key={booking.id} className="col-12 col-md-6 col-lg-4">
                <div className="card booking-card">
                  <div className="card-image">
                    <Link to={`/${slugify(booking.title)}`}>
                      <img
                        src={booking.imgSrc}
                        className="card-img-top"
                        alt={booking.title}
                      />
                    </Link>
                  </div>
                  <div className="card-content">
                    <div className="content-border">
                      <h3 className="card-title text-white">{booking.title}</h3>
                      <p className="card-description text-white">{booking.description}</p>
                      {/* <a
                        href={`https://wa.me/919356411908?text=Hi%20Etravo%2C%20I%20would%20like%20to%20book%20the%20${encodeURIComponent(
                          booking.title
                        )}.`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button className="btn btn-primary">Book Now</button>
                      </a> */}
<Link to="/enquiry">
  <button className="btn btn-primary">Boooking & Enquiry</button>
</Link>
                      

                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Ourfleet;